import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupComponent } from './group.component'; // Adjust the path if necessary
import { ToastrModule } from 'ngx-toastr'; // For notifications
import { ModalModule } from 'ngx-bootstrap/modal'; // For modals
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; // If you are using reactive forms
import { GroupService } from '../providers/group.service'; // Ensure the path is correct
import { SigninService } from 'src/app/authentification/signin/signin.service'; // Ensure the path is correct
import { NgxLoadingModule } from 'ngx-loading';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    GroupComponent // Declare your component here
  ],
  imports: [
    CommonModule,
    FormsModule,
    ToastrModule.forRoot(), // Import Toastr module for notifications
    ModalModule.forRoot(), // Import Bootstrap modal module
    ReactiveFormsModule,
    NgxLoadingModule.forRoot({}),
    PaginationModule.forRoot(),
    RouterModule
  ],
  providers: [
    GroupService, // Provide the group service
    SigninService // Provide the signin service if needed
  ],
  exports: [
    GroupComponent // Export if you want to use this component outside of this module
  ]
})
export class GroupModule { }
